import React, { useState } from 'react'
import Container from './Container'
import { ContentBlock, ExpandableBlocks } from 'components/ContentBlock'
import DropdownMenus from './DropdownMenus'

import { StyledDnDContentSide } from './styled/common'
import { ThirdView } from './ThirdView/ThirdView'

const DragAndDrop = (props) => {
	const [is3dShown, setIs3dShown] = useState(false)
	return (
		<ExpandableBlocks nested>
			<ContentBlock
				alwaysExpanded
				style={{ marginTop: '10px' }}
				label={<DropdownMenus
					is3dShown={is3dShown}
					toggle3d={() => setIs3dShown(prevValue => !prevValue)}
					{...props}
				/>}
				unmountOnCollapse={true}
			>
				<StyledDnDContentSide>
					{is3dShown
						? <ThirdView {...props} />
						: <Container {...props} />
					}
				</StyledDnDContentSide>
			</ContentBlock>
		</ExpandableBlocks>
	)
}

export default DragAndDrop
